<template>
	<!-- <div class="machine"> -->
		<el-dialog 
      title="机卡分离" 
      :visible.sync="show" 
      width="400" 
      :before-close="handleClose"
    >
      <div class="search">
        <el-input v-model.trim="card" placeholder="请输入卡号"  />
        <el-button @click="onSearch" type="primary" >查询</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        size="small"
        height="340px">
        <el-table-column prop="index" label="序号" width="60" v-slot="{ $index }">{{ $index }}</el-table-column>
        <el-table-column prop="operateTime" label="时间" min-width="180"></el-table-column>
        <el-table-column prop="statusName" label="内容" min-width="180"></el-table-column>
      </el-table>
		</el-dialog>
	<!-- </div> -->
</template>

<script>
export default {
	name: 'machineCardSeparation',
	props: {
		visible: {
			type: Boolean,
			default: false,
    },
    info: {
      type: Object,
      default:{}
    }
	},
	data() {
		return {
      card: '',
      tableData:[]
		};
  },
  computed: {
    show: {
      get(){
        return this.visible;
      },
      set(val){
        return this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: {
      handler (val) {
        val && this.init();
      },
      deep:true
    }
  },
  methods: {
    // 获取记录
    async getData () {
      try {
        if (!this.card) throw { msg:'请输入卡号' };
        const { msg, code, data } = await this.$API.getCardBindStatusRecord({ 
          card: this.card,
          pageNumber: 1,
          pageSize:200
        });
        if (code !== 0) throw { msg };
        this.tableData = data;
      } catch ({ msg }) {
        this.tableData = [];
        this.$message.warning(msg);
      }
    },
    // 搜索机卡分离
    async onSearch () {
      try {
        if (!this.card) throw { msg:'请输入卡号' };
        this.tableData = [];
        const { msg, code } = await this.$API.queryCardBindStatus({ card: this.card });
        if (code !== 0) throw { msg };
        this.getData();
      } catch ({ msg }) {
        this.$message.warning(msg);
      }
    },
    // 初始化
    init () {
      if(this.info){
        this.card = this.info.simCard;
        this.getData();
      } else {
        this.card = '';
      }
    },
		handleClose() {
			this.$emit('update:visible',false);
		},
	},
};
</script>

<style lang="scss" scoped>
.search{
  display: flex;
  width: 60%;
  margin-bottom: 15px;
  >button{
    margin-left: 15px;
    border-radius: 4px !important;
  }
}
</style>
